import { Box, Typography, IconButton } from '@mui/material'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getFromStorage } from '../utils/storage'
import { updateFormActions } from '../redux/store'
import DeleteIcon from '@mui/icons-material/Delete'
import { socket } from '../utils/socket'
import ContentCutIcon from '@mui/icons-material/ContentCut'
import { orderPanelStyles } from './common/orderPanelStyles'
import Loading from './Loading'
import ExtendedIconButton from './button-icons/ExtendedIconButton'
import PanelOrderItem from './PanelOrderItem'
import { mainRed } from '../utils/color'
import { OrderStatus } from '../models'
import { enqueueSnackbar } from 'notistack'

export default function SuccessOrderPanel({ successOrdersProps }) {
	const dispatch = useDispatch()
	const { isLoading } = useSelector((state) => state.isLoading)
	const { currentUser } = useSelector((state) => state.currentUser)
	const token = getFromStorage('current-user')?.accessToken
	const [expandedOrders, setExpandedOrders] = useState({})

	const waitConfirmDeleteOrder = async function (data) {
		socket.emit('wait-confirm-delete-order', data)
	}

	console.log(successOrdersProps)

	if (isLoading) return <Loading />

	return (
		<Box sx={orderPanelStyles.container}>
			<Box sx={orderPanelStyles.ordersBox}>
				{successOrdersProps.map((order) => (
					<PanelOrderItem
						key={order._id}
						order={order}
						expandedOrders={expandedOrders}
						renderActions={() => (
							<Box sx={orderPanelStyles.actionIcons}>
								{!(order.quickPurchase ?? false) &&
									order.status !== OrderStatus.PENDING_DELETE_SUCCESS &&
									order.status !== OrderStatus.CONFIRM_DELETE_SUCCESS && (
										<>
											{order.shipper?.shipEnd != null && currentUser?.permission?.includes('updateSuccessOrder') && (
												<IconButton
													size='small'
													onClick={() => {
														const payload = {
															...order,
														}
														dispatch(updateFormActions.editOrder(payload))
														dispatch(updateFormActions.showUpdateForm())
													}}
													sx={{ color: '#9C27B0' }}>
													<ContentCutIcon fontSize='small' />
												</IconButton>
											)}

											{order.shipper?.shipEnd != null && currentUser?.permission?.includes('deleteOrder') && (
												<IconButton
													size='small'
													onClick={() => {
														const deleteReason = window.prompt('Nhập lý do hủy')
														if (!deleteReason || deleteReason.trim() === '') {
															alert('Lý do hủy không được để trống!')
														} else {
															waitConfirmDeleteOrder({
																deletor: currentUser.id,
																storeId: currentUser.store,
																orderId: order._id,
																accessToken: token,
																deleteReason,
															})
															enqueueSnackbar('Chờ xác nhận xóa đơn hàng!')
														}
													}}
													sx={{ color: mainRed }}>
													<DeleteIcon fontSize='small' />
												</IconButton>
											)}
										</>
									)}

								{(order.quickPurchase ?? false) && (
									<>
										{order.status !== OrderStatus.PENDING_DELETE_SUCCESS &&
											order.status !== OrderStatus.CONFIRM_DELETE_SUCCESS && (
												<>
													{currentUser?.permission?.includes('updateSuccessOrder') && (
														<IconButton
															size='small'
															onClick={() => {
																const payload = {
																	...order,
																}
																dispatch(updateFormActions.editOrder(payload))
																dispatch(updateFormActions.showUpdateForm())
															}}
															sx={{ color: '#9C27B0' }}>
															<ContentCutIcon fontSize='small' />
														</IconButton>
													)}

													{order.status !== OrderStatus.PENDING_PRODUCE_QUICK &&
														currentUser?.permission?.includes('deleteOrder') && (
															<IconButton
																size='small'
																onClick={() => {
																	const deleteReason = window.prompt('Nhập lý do hủy')
																	if (!deleteReason || deleteReason.trim() === '') {
																		alert('Lý do hủy không được để trống!')
																	} else {
																		waitConfirmDeleteOrder({
																			deletor: currentUser.id,
																			storeId: currentUser.store,
																			orderId: order._id,
																			accessToken: token,
																			deleteReason,
																		})
																		enqueueSnackbar('Chờ xác nhận xóa đơn hàng!')
																	}
																}}
																sx={{ color: mainRed }}>
																<DeleteIcon fontSize='small' />
															</IconButton>
														)}
												</>
											)}
									</>
								)}

								{(order?.source || order?.code) && (
									<ExtendedIconButton
										isExpanded={expandedOrders[order._id]}
										onClick={() => setExpandedOrders((prev) => ({ ...prev, [order._id]: !prev[order._id] }))}
									/>
								)}
							</Box>
						)}
					/>
				))}
			</Box>

			{successOrdersProps?.length === 0 && (
				<Typography variant='h6' sx={orderPanelStyles.emptyMessage}>
					Chưa có đơn hàng thành công
				</Typography>
			)}
		</Box>
	)
}
